/**
 * Ajaxで取得した教室の地図をモーダルで表示する
 *
 */

/**
 * LPモーダルウィンドウイベントを登録する
 */
function registKoushaMapModalEvent() {
	var Modal = {
		/** スクロール位置保存用 */
		_currentScrollY: 0,
		/**
		 * モーダルを開く共通処理
		 * スクロールをロックし、前処理・後処理を実行してオーバーレイを表示する
		 * @param {jQuery} clickElement モーダルを開くボタン
		 * @param {jQuery} modalElement モーダルの枠(class="js-modal-window")
		 * @param {Function} beforeFunc オーバーレイ表示前に実行する関数
		 * @param {Function} afterFunc オーバーレイ表示後に実行する関数
		 */
		open: function(clickElement, modalElement, beforeFunc, afterFunc) {
			// スクロール位置保存、固定
			this._lockScroll();
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc(clickElement, modalElement);
			// オーバーレイ表示
			modalElement.children('.js-modal-window-box, .js-kousha-map-modal-window-box').fadeIn('fast', function(){
				// 後処理
				if (typeof(afterFunc) === 'function') afterFunc(clickElement, modalElement);
			});
		},
		
		/**
		 * モーダルを閉じる共通処理
		 * 前処理・後処理を実行してオーバーレイを非表示にし、スクロールロックを解除する
		 * @param {Function} beforeFunc オーバーレイ非表示前に実行する関数
		 * @param {Function} afterFunc オーバーレイ非表示後に実行する関数
		 */
		close: function(beforeFunc, afterFunc) {
			// 前処理
			if (typeof(beforeFunc) === 'function') beforeFunc();
			// オーバーレイ非表示
			$('.js-modal-window-box:visible, .js-kousha-map-modal-window-box:visible').fadeOut();
			// モーダルの中身非表示
			$('.js-modal-window-box-inner:visible, .js-kousha-map-modal-window-box-inner:visible').fadeOut();
			// 後処理
			if (typeof(afterFunc) === 'function') afterFunc();
			// スクロール位置復元、固定解除
			this.unlockScroll();
		},
		
		/**
		 * スクロール位置を保存し、スクロールを固定する
		 * iOS15のバグ対策として異なるスタイルを適用する
		 */
		_lockScroll: function() {
			this._currentScrollY = $(window).scrollTop();
			if(location.pathname.indexOf('iphone') !== -1){
				//'iphone'つきのURLを参照していたらSPと判定

				// iOS15のバグでアドレスバーの背景だけ表示されて見た目が変なため、bodyにmin-height:100vh; orverflow:hidden; を設定することで対処
				// 正しいやり方かどうか不明。後から検証したほうが良い
				$('body').css('min-height', '100vh');
				$('body').css('overflow', 'hidden');
				// $('body').css('position', 'fixed');
				// $('body').css('width', '100%');
				// $('body').css('top', -1 * this._currentScrollY);
			} else {
				//それ以外は全てPCと判定
				$('body').css('overflow', 'hidden');
			}
		},
		
		/**
		 * スクロール固定を解除し、位置を復元する
		 */
		unlockScroll: function() {
			$('body').css('overflow', '');
			$(window).scrollTop(this._currentScrollY);
		}
	};

	/** 教室地図モーダル 開くイベント */
	$(document).on('click', '.js-kousha-map-modal-open', function(e){
		e.preventDefault();
    	e.stopPropagation();
		koushaMapModalOpen($(this), $('#js-kousha-map-modal'));
	});

	/**
	 * 教室地図モーダルの内容を取得・表示する
	 * Ajaxで教室データを取得し、モーダルに表示してGoogle Mapsを読み込む
	 * @param {jQuery} clickElement モーダルを開くボタン要素
	 * @param {jQuery} modalElement モーダル要素
	 */
	function koushaMapModalOpen(clickElement, modalElement) {

		Modal.open(
			clickElement,
			modalElement,
			function(clickElement, modalElement){
				// loading画像表示
				if (typeof(loadingPopup) == 'function') {
					loadingPopup();
				}
				// データ取得
				let dataUrl = clickElement.data('url');
				$.ajax({
					type: 'POST',
					url: dataUrl,
					datatype: 'json',
					cache: false,
				}).done(function(data) {
					let area = modalElement.find('.js-kousha-map-modal-window-cont');
					// 取得したデータをモーダルに反映
					area.find('[data-bind]').each(function () {
					if ($(this).is('input')) {
						$(this).val(data.response[$(this).data('bind')]);
					} else {
						$(this).text(data.response[$(this).data('bind')]);
					}
					});

					// loading画像非表示
					$('body').find('.js-loading-popup').remove();
					// モーダルコンテンツ表示
					modalElement.children('.js-kousha-map-modal-window-box-inner').fadeIn('fast', function(){
						// 後処理が必要な場合はここに記載
					});

					// 地図を表示（site/View/Elements/map/google_map_api.tplの読み込み前提）
					loadKoushaMapForKoushaModal(modalElement);

					// ajaxで取得するためイベントを再登録する
					trackEvent.bindEventOnElements(modalElement.find('.js-kousha-map-modal-window-cont'));
				}).fail(function () {
					$('body').find('.js-loading-popup').remove();
					$('.js-kousha-map-modal-window-box:visible').hide();
					// 失敗した場合はスクロールロックを解除
					Modal.unlockScroll();
					alert('データを取得できませんでした。');
				});
			},
			null
		);
	};
	
	/** 教室地図モーダル 閉じるイベント(オーバーレイ) */
	$(document).on('click', '.js-kousha-map-modal-window-box', function(){
		if ($('.js-kousha-map-modal-window-box').is(':visible') && $('.js-kousha-map-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length == 0) {
			Modal.close();
		}
	});
	/** 教室地図モーダル 閉じるイベント(×ボタン) */
	$(document).on('click', '.js-kousha-map-modal-window-close', function(){
		if ($('.js-kousha-map-modal-window-box').is(':visible') && $('.js-kousha-map-modal-window-box-inner').is(':visible') && $('body').find('.js-loading-popup').length == 0) {
			Modal.close();
		}
	});
}

/**
 * モーダル内の教室の地図を読み込む(教室地図モーダル用)
 * 教室の緯度経度情報を取得してGoogle Mapsを表示する(PC版)
 * @param {jQuery} modalElement モーダル要素
 */
function loadKoushaMapForKoushaModal(modalElement) {
	let disp = $('#js-kousha-map-modal').find('#kousha_map_canvas')[0];
	let lat = modalElement.find('.detail_kousha_lat').attr("value");
	let lon = modalElement.find('.detail_kousha_lon').attr("value");
	const mapModalCommon = new MapModalCommon(disp, lat, lon);
	mapModalCommon.loadKoushaMapDefaultPc();
}

/**
 * ページロード後に処理を走らせる
 */
$(function(){
    registKoushaMapModalEvent();
});
